var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",on:{"click":function($event){return _vm.back()}}},[_c('i',{staticClass:"fas fa-long-arrow-alt-left"}),_vm._v(" "+_vm._s(_vm.$t('pagelayout.back'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }